import React from "react";
import { IIndustryEventResult } from "../../lib/models/IIndustryEvents";

export default function TourismEventResult({
  data
}: {
  data: IIndustryEventResult;
}) {
  return (
    <div className="col-12">
      <a href={data.url} target="_self">
        <div className="industry-event-listing">
          <div className="main">
            <p className="date">{data.dateRange}</p>
            <h3>{data.name}</h3>
            <div className="small-info">
              {data.eventTime && (
                <div>
                  <p className="header">Time</p>
                  <p className="detail">{data.eventTime}</p>
                </div>
              )}
              {data.location && (
                <div>
                  <p className="header">Location</p>
                  <p className="detail">{data.location}</p>
                </div>
              )}
              {data.hostedBy && (
                <div>
                  <p className="header">Hosted By</p>
                  <p className="detail">{data.hostedBy}</p>
                </div>
              )}
            </div>
            <p className="teaser">{data.teaserText}</p>
          </div>
          <p className="btn-primary">View details</p>
        </div>
      </a>
    </div>
  );
}
